import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "../components/MailchimpForm";
import logo from "../assets/img/TotleSoft.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={8} sm={4}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.facebook.com/totlesoftmedia/"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Copyright (c) 2014 - 2023. TotleSoft</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
